export const NEWSLETTER = 'newsletter'
